module.exports = __webpack_public_path__ + "img/blog-2.0a808b71.jpg";